import * as React from 'react';
import type { SVGProps } from 'react';
const SvgMoney = (props: SVGProps<SVGSVGElement>) => (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2.25 1.5H0V3.75C1.24264 3.75 2.25 2.74264 2.25 1.5Z" fill="#616061" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.75 1.5C3.75 3.57107 2.07107 5.25 0 5.25V6.75C2.07107 6.75 3.75 8.42893 3.75 10.5H8.25C8.25 8.42893 9.92893 6.75 12 6.75V5.25C9.92893 5.25 8.25 3.57107 8.25 1.5H3.75ZM6 7.5C6.82843 7.5 7.5 6.82843 7.5 6C7.5 5.17157 6.82843 4.5 6 4.5C5.17157 4.5 4.5 5.17157 4.5 6C4.5 6.82843 5.17157 7.5 6 7.5Z"
      fill="#616061"
    />
    <path d="M12 1.5V3.75C10.7574 3.75 9.75 2.74264 9.75 1.5H12Z" fill="#616061" />
    <path d="M12 10.5H9.75C9.75 9.25736 10.7574 8.25 12 8.25V10.5Z" fill="#616061" />
    <path d="M2.25 10.5C2.25 9.25736 1.24264 8.25 0 8.25V10.5H2.25Z" fill="#616061" />
  </svg>
);
export default SvgMoney;
